import { useLang } from '../context/LanguageContext';
import { SOCIAL } from '../config/business';
import FooterAboutLeadership from '../components/FooterAboutLeadership';
import './AboutPage.css';

export default function AboutPage({ onClose }) {
  const { t } = useLang();
  return (
    <div className="page-modal-backdrop" onClick={onClose}>
      <div className="page-modal" onClick={e => e.stopPropagation()}>
        <div className="page-modal-header">
          <h2>{t.about}</h2>
          <button className="page-modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="page-modal-body">
          <div className="about-hero">
            <img src="/rk-logo.webp" alt={t.brandName} className="about-logo" />
            <h1>{t.brandName}</h1>
            <p className="about-tagline">{t.aboutHeroTagline}</p>
          </div>

          <FooterAboutLeadership className="about-leadership-section--modal" />

          <div className="about-section">
            <h3>{t.aboutSectionHeading}</h3>
            <p>{t.aboutText}</p>
          </div>

          <div className="about-stats-grid">
            <div className="about-stat-card">
              <span className="about-stat-icon">📖</span>
              <span className="about-stat-val">2015</span>
              <span className="about-stat-lbl">{t.aboutStatMonthly}</span>
            </div>
            <div className="about-stat-card">
              <span className="about-stat-icon">📰</span>
              <span className="about-stat-val">2018</span>
              <span className="about-stat-lbl">{t.aboutStatDaily}</span>
            </div>
            <div className="about-stat-card">
              <span className="about-stat-icon">📍</span>
              <span className="about-stat-val">{t.aboutStatState}</span>
              <span className="about-stat-lbl">{t.aboutStatStateLabel}</span>
            </div>
          </div>

          <div className="about-section">
            <h3>{t.aboutSocialMedia}</h3>
            <div className="about-social">
              <a href={SOCIAL.youtube} target="_blank" rel="noreferrer" className="about-social-btn youtube">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.7 15.5V8.5l6.3 3.5-6.3 3.5z"/></svg>
                {t.youtube}
              </a>
              <a href={SOCIAL.instagram} target="_blank" rel="noreferrer" className="about-social-btn instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                  <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.9.2 2.3.4.6.2 1 .5 1.5 1 .4.4.7.9.9 1.5.2.4.4 1.1.4 2.3.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.2 1.9-.4 2.3-.2.6-.5 1-1 1.5-.4.4-.9.7-1.5.9-.4.2-1.1.4-2.3.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.9-.2-2.3-.4-.6-.2-1-.5-1.5-1-.4-.4-.7-.9-.9-1.5-.2-.4-.4-1.1-.4-2.3-.1-1.3-.1-1.7-.1-4.9s0-3.6.1-4.9c.1-1.2.2-1.9.4-2.3.2-.6.5-1 1-1.5.4-.4.9-.7 1.5-.9.4-.2 1.1-.4 2.3-.4C8.4 2.2 8.8 2.2 12 2.2zm0 1.8c-3.1 0-3.5 0-4.7.1-1 .0-1.6.2-2 .3-.5.2-.8.4-1.1.7-.3.3-.5.6-.7 1.1-.1.4-.3 1-.3 2-.1 1.2-.1 1.6-.1 4.7s0 3.5.1 4.7c0 1 .2 1.6.3 2 .2.5.4.8.7 1.1.3.3.6.5 1.1.7.4.1 1 .3 2 .3 1.2.1 1.6.1 4.7.1s3.5 0 4.7-.1c1 0 1.6-.2 2-.3.5-.2.8-.4 1.1-.7.3-.3.5-.6.7-1.1.1-.4.3-1 .3-2 .1-1.2.1-1.6.1-4.7s0-3.5-.1-4.7c0-1-.2-1.6-.3-2-.2-.5-.4-.8-.7-1.1-.3-.3-.6-.5-1.1-.7-.4-.1-1-.3-2-.3-1.2-.1-1.6-.1-4.7-.1zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4zm5.3-3.3a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z" />
                </svg>
                {t.instagram}
              </a>
              <a href={SOCIAL.facebook} target="_blank" rel="noreferrer" className="about-social-btn facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.07C24 5.41 18.63 0 12 0S0 5.41 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.95.93-1.95 1.88v2.27h3.32l-.53 3.5h-2.79V24C19.61 23.1 24 18.1 24 12.07z"/></svg>
                {t.facebook}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
